"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";

export default function ScrollToTop() {
  const pathname = usePathname();
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }

    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "instant",
    });
  }, [pathname]);

  return null;
}
